// extracted by mini-css-extract-plugin
export default {"commentInfo":"index_commentInfo__cvcaQ","titleLine":"index_titleLine__CSBlO","mainTitle":"index_mainTitle__3qQV8","point":"index_point__8ETP6"};